export default class Util  {

	static IsNullOrEmpty(str) {
        return str === undefined || str === "" || str === null;
	}
}


// WEBPACK FOOTER //
// ./src/Util/Util.js